/* Millesève — galerie de la fiche produit (E3.1). DS §10.6, §11, §13.
   Remplace media-gallery.js de Dawn : même élément <media-gallery> et même méthode setActiveMedia(),
   que product-info.js appelle quand on change de variante.
   - Toutes les vues sont empilées ; la vue active passe à opacité 1 (fondu --dur-slow, 0 s en mouvement réduit).
   - Changement de variante : product-info.js recharge la section ; la galerie reçue (ordre calculé en Liquid,
     vue 1 = image de la variante) donne le nouvel ordre des vues et des vignettes, puis la vue 1 s'affiche.
   - Clavier : Tab / Entrée / Espace sur les vignettes ; flèches, Origine et Fin pour passer de l'une à l'autre. */
if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MsGalerie extends HTMLElement {
      connectedCallback() {
        this.viewer = this.querySelector('.ms-galerie__principale');
        this.vignettes = this.querySelector('.ms-galerie__vignettes');
        if (!this.viewer) return;
        if (!this.autoplayStarted) {
  this.autoplayStarted = true;
  this.autoplayTimer = setInterval(() => {
    if (this.matches(':hover') || this.contains(document.activeElement)) return;

    const vues = [...this.viewer.querySelectorAll('.ms-galerie__vue[data-media-id]')];
    if (vues.length < 2) return;

    const activeIndex = vues.findIndex((vue) => vue.classList.contains('is-active'));
    const nextIndex = (activeIndex + 1) % vues.length;
    this.setActiveMedia(vues[nextIndex].dataset.mediaId);
  }, 4000);
}

        if (this.vignettes && !this.ecoute) {
          this.ecoute = true;
          this.vignettes.addEventListener('click', (e) => {
            const bouton = e.target.closest('button[data-target]');
            if (bouton) this.setActiveMedia(bouton.dataset.target);
          });
          this.vignettes.addEventListener('keydown', this.onKeydown.bind(this));
        }

        if (!this.desabonne && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.desabonne = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
        }
      }

      disconnectedCallback() {
        this.desabonne?.();
        this.desabonne = null;
      }

      /* Appelée par les vignettes et par product-info.js (le second argument de Dawn, prepend, est ignoré :
         l'ordre vient de la galerie rechargée). */
      setActiveMedia(mediaId) {
        const vues = [...this.viewer.querySelectorAll('[data-media-id]')];
        const cible = vues.find((vue) => vue.dataset.mediaId === mediaId) || vues[0];
        if (!cible) return;

        vues.forEach((vue) => {
          const active = vue === cible;
          vue.classList.toggle('is-active', active);
          if (active) vue.removeAttribute('aria-hidden');
          else vue.setAttribute('aria-hidden', 'true');
        });
        const image = cible.querySelector('img');
        if (image && image.loading === 'lazy') image.loading = 'eager';

        this.boutons().forEach((bouton) =>
          bouton.setAttribute('aria-current', String(bouton.dataset.target === cible.dataset.mediaId))
        );
      }

      onVariantChange(event) {
        const html = event?.data?.html;
        const recue = html?.querySelector(`media-gallery#${CSS.escape(this.id)}`);
        if (!recue) return;

        const ordre = [...recue.querySelectorAll('.ms-galerie__vue[data-media-id]')].map((vue) => vue.dataset.mediaId);
        if (!ordre.length) return;

        ordre.forEach((id) => {
          const vue = this.viewer.querySelector(`[data-media-id="${CSS.escape(id)}"]`);
          if (vue) this.viewer.append(vue);
        });
        if (this.vignettes) {
          const focus = this.vignettes.contains(document.activeElement) ? document.activeElement : null;
          ordre.forEach((id) => {
            const bouton = this.vignettes.querySelector(`button[data-target="${CSS.escape(id)}"]`);
            const modele = recue.querySelector(`button[data-target="${CSS.escape(id)}"]`);
            if (!bouton) return;
            if (modele) bouton.setAttribute('aria-label', modele.getAttribute('aria-label'));
            this.vignettes.append(bouton);
          });
          focus?.focus();
        }
        this.setActiveMedia(ordre[0]);
      }

      onKeydown(event) {
        const boutons = this.boutons();
        const i = boutons.indexOf(event.target.closest('button[data-target]'));
        if (i < 0) return;
        let j;
        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            j = (i + 1) % boutons.length;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            j = (i - 1 + boutons.length) % boutons.length;
            break;
          case 'Home':
            j = 0;
            break;
          case 'End':
            j = boutons.length - 1;
            break;
          default:
            return;
        }
        event.preventDefault();
        boutons[j].focus();
        this.setActiveMedia(boutons[j].dataset.target);
      }

      boutons() {
        return this.vignettes ? [...this.vignettes.querySelectorAll('button[data-target]')] : [];
      }
    }
  );
}
